import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
//import { FaQModel } from '../models/faq.model';
import { CallModel } from '../models/calllog.model';
import { IssueModel } from '../models/issue.model';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private messageSource = new Subject<string>();

  //private faqSource = new Subject<FaQModel>();
  private callSource = new Subject<CallModel>();
  private issueSource = new Subject<IssueModel>();
  private tagSource = new Subject<boolean>();

  messageTransfer = this.messageSource.asObservable();
  callTransfer = this.callSource.asObservable();
  issueTransfer = this.issueSource.asObservable();
  tagTransfer = this.tagSource.asObservable();

  constructor() { }

  sendMessage(message : string){
    this.messageSource.next(message);

  }
/*
  sendFaQ(data : FaQModel){
    this.faqSource.next(data);

  }*/

  sendCallStatus(data : CallModel){
    this.callSource.next(data);

  }

  sendCurrentIssue(data : IssueModel){
    this.issueSource.next(data);

  }

  sendTag(data : boolean){
    this.tagSource.next(data);

  }

}
